import { Axios } from './Axios';

export function getAllCalenderEvents(orgId) {
  const url = `events/calender?orgId=${orgId}`;
  return Axios({
    url,
    method: 'get'
  });
}

export function createNewCalenderEvent(calenderEventObj) {
  const url = 'events/calender';
  return Axios({
    url,
    method: 'post',
    data: calenderEventObj
  });
}

export function updateCalenderEvent(eventId, obj) {
  const url = `events/calender?eventId=${eventId}`;
  return Axios({
    url,
    method: 'patch',
    data: obj
  });
}

export function deleteCalenderEvent(eventId) {
  const url = `events/calender?eventId=${eventId}`;
  return Axios({
    url,
    method: 'delete'
  });
}
